import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { equals } from 'lodash/fp';
import validateEmail from '@/helpers/validateEmail';

@Component
class Login extends Vue {
  @Getter isLogging;

  @Action fetchBookingByPnr;

  email = '';

  pnr = '';

  emailError = false;

  get isEmailValid() {
    return validateEmail(this.email);
  }

  get isPnrValid() {
    return equals(6, this.pnr.length);
  }

  validateEmail() {
    if (this.email && !this.isEmailValid) {
      this.emailError = true;
    }
  }

  onPnrChange(e) {
    const re = /[^A-Z0-9]/gi;
    this.pnr = e.target.value.replace(re, '').toUpperCase();
  }

  onEmailChange(e) {
    this.email = e.target.value.toLowerCase();
    this.emailError = false;
  }

  onLogin() {
    const { email, pnr } = this;
    this.$router.push({ path: 'pnr-booking', query: { email, pnr } });
  }
}

export default Login;
